import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "relationship",
        "firstName",
        "lastName",
        "firstNameLabel",
        "lastNameLabel"
    ]

    static values = {
        currentRelationship: String,
        currentFirstName: String,
        currentLastName: String
    }

    connect() {
        this.toggleAccountManager()
    }

    toggleAccountManager() {
        const serviceUserSelected = this.relationshipTarget.value === "service_user"

        this.firstNameTarget.disabled = serviceUserSelected
        this.lastNameTarget.disabled = serviceUserSelected

        this.firstNameTarget.required = !serviceUserSelected
        this.lastNameTarget.required = !serviceUserSelected

        if (serviceUserSelected) {
            this.firstNameTarget.value = ""
            this.lastNameTarget.value = ""
        } else if (this.relationshipTarget.value === this.currentRelationshipValue) {
            this.firstNameTarget.value = this.currentFirstNameValue || ""
            this.lastNameTarget.value = this.currentLastNameValue || ""
        }

        this.firstNameTarget.classList.toggle("bg-slate-100", serviceUserSelected)
        this.lastNameTarget.classList.toggle("bg-slate-100", serviceUserSelected)
        this.firstNameTarget.classList.toggle("text-slate-400", serviceUserSelected)
        this.lastNameTarget.classList.toggle("text-slate-400", serviceUserSelected)
    }
}